export interface Tag {
    EN: string;
    FR: string;
}

export interface TagList {
    categories: Tag[];
    sectors: Tag[];
    themes: Tag[];
}

export const isTagForAll = (tag: Tag): boolean => tag.FR.startsWith('Tous');
